import { Routes, RouterModule } from '@angular/router';
import { ProductList } from './productlist.list';

export const routes: Routes = [
    {
        path: 'productedit/:id',
        data: { reuse: false },
        loadChildren: () =>
            import('../productdetail/productdetail.module').then(
                (mod) => mod.ProductDetailModule
            ),
    },
    { path: 'page/productlist', component: ProductList },
    { path: '', redirectTo: 'page/productlist', pathMatch: 'full' },
];

export const PRODUCTLIST_ROUTER_PROVIDERS = RouterModule.forRoot(routes);
